export default __webpack_public_path__ + "static/media/Retail.b3bf0757.svg";